import { Injectable } from '@angular/core';

import { ApiService } from '../api.service';
import { UserProfileService } from './user-profile.service';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataObject, OpportunityInstallmentObject } from '../interfaces/data-objects';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SalesforceService {

  constructor(
    private api: ApiService,
    private userProfileService: UserProfileService
  ) { }

  getOpportunities(query: string, searchBy = 'name',isDeepLinking = false, sourceSystem = null): Observable<any[]> {
    const isSalesForceAPI = this.userProfileService.getSalesForceAPI();
    const endPoint = isSalesForceAPI ? 'salesforce' : 'edpsalesforce';
    const apiEndPoint = isSalesForceAPI ? `/api/${endPoint}/opportunities/?q=${encodeURIComponent(query)}&is_opportunity_via_deeplinking=${isDeepLinking}&sort=${searchBy}&source_system=${sourceSystem}`
                         : `/api/${endPoint}/opportunities/?q=${encodeURIComponent(query)}&sort=${searchBy}`;
    return this.api.get(apiEndPoint)
      .pipe(
        map(response => {
          if (isSalesForceAPI) {
            if (sourceSystem === 'OSS') {
              return this.getOssOpportunityInfo(response.results);
            }
            return response?.results?.records?.map((record: any) => this.getCiqOpportunityInfo(record));
          } else {
            if (response && response.results) {
              return response.results;
            }
          }
        }
      ));
  }

  // INFO: Maps the response from the SalesForce API to the format that the UI is expecting
  getCiqOpportunityInfo(record: any) {
    let newRecord = [];
    newRecord['opportunity_id'] = record['Id'];
    newRecord['opp_name'] = record['Name'];
    newRecord['opportunity_number'] = record['Opportunity_No__c'];
    newRecord['account_id'] = record['AccountId'];
    newRecord['account_name'] = record['Original_Account_Name__c'];
    return newRecord;
  }

  // INFO: Maps the response from the OSS API to the format that the UI is expecting
  getOssOpportunityInfo(record: any) {
    let newRecord = [];
    newRecord['opportunity_id'] = record['opportunityId'] || '';
    newRecord['opp_name'] = record['opportunityName'] || null;
    newRecord['opportunity_number'] = record['salesforceNo'] || '';
    // INFO: Existing CIQ integration returns an array of objects, we need to keep the OSS integration consistent
    return [newRecord];
  }
  
  // INFO: This API is only for the new SalesForce API integration
  getInstallments(params: OpportunityInstallmentObject): Observable<any[]> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('opportunity_id', params.sourceSystem === 'OSS' ? params.opportunityNumber : params.opportunityId);
    queryParams = queryParams.append('source_system', params.sourceSystem);

    return this.api.get(`/api/salesforce/opportunity_installments/`, { params: queryParams })
      .pipe(
        map((response) => this.mapInstallmentResponse(params.sourceSystem, response))
      );
  }

  mapInstallmentResponse(sourceSystem: string | null, response: any): DataObject[] {
    if (sourceSystem === 'OSS') {
      return response.results?.map((record: any) => {
        let installment = [];
        installment['label'] = `${record.name} | ${record.installmentDate} | ${record.installmentAmount}`;
        installment['value'] = record.name;
        return installment;
      });
    }
    return response.results?.records.map((record: any) => {
      let installment = [];
      installment['label'] = `${record.Name} | ${record.Installment_Date_frm__c} | ${record.Installment_Amount_frm__c} | ${record.Installment_Status__c}`;
      installment['value'] = record.Name;
      return installment;
    });
  };
}
